module.exports = __webpack_public_path__ + "img/水质监测.f3a3045e.png";